import * as yup from 'yup';
import { detailsStepSchema } from './steps/detailsStep/schema';
import { availabilityStepSchema } from './steps/availabilityStep/schema';

export const createProjectSchema = yup.object().concat(detailsStepSchema).concat(availabilityStepSchema);
